@import "tailwindcss";

@theme {
  --color-primary-50: #f6eef0;
  --color-primary-100: #ead9de;
  --color-primary-200: #d9b6bf;
  --color-primary-300: #be8a99;
  --color-primary-400: #9b5e72;
  --color-primary-500: #7f3e56;
  --color-primary-600: #6e1f3d;
  --color-primary-700: #5a1832;
  --color-primary-800: #451127;
  --color-primary-900: #320a1c;
  --color-primary-950: #1a040f;

  --color-accent-lime-100: #e4f7c4;
  --color-accent-lime-300: #b5ea53;
  --color-accent-lime-500: #94d728;
  --color-accent-lime-700: #5c8d0f;
}

@layer base {
  :root {
    font-family: "Poppins", "Segoe UI", sans-serif;
    line-height: 1.45;
    font-weight: 400;
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    scroll-behavior: smooth;
    background: #f8fafc;
    color: #0f172a;
  }

  body {
    margin: 0;
    min-width: 320px;
    min-height: 100vh;
    background: inherit;
    color: inherit;
  }

  html[data-theme="dark"] {
    background: #0f172a;
    color: #f8f4ef;
  }

  html[data-theme="light"] {
    background: #f8fafc;
    color: #0f172a;
  }

  html[data-theme="dark"] body {
    background: #0f172a;
    color: #f8f4ef;
  }

  html[data-theme="light"] body {
    background: #f8fafc;
    color: #0f172a;
  }

  #root {
    min-height: 100vh;
  }

  input,
  textarea,
  select {
    color: #111827;
  }

  input::placeholder,
  textarea::placeholder,
  select::placeholder {
    color: rgba(55, 65, 81, 0.55);
  }
}
